import React, { Component } from "react";
import { connect } from "react-redux";

import { injectIntl, FormattedMessage } from "react-intl";

import { setPredictionQuestionAnswer } from "../store/actions";
import "./predictionsOutcomeQuestion.scss";

/**
 * POSCQ - Prediction Outcome Single Choice Question Component.
 *
 * This component renders a single choice question with radio button options.
 * It allows users to select one of the provided choices.
 */
class POSCQ extends Component {
  /**
   * Handles the change event of the radio buttons.
   *
   * @param {number} option - The index of the selected option.
   * @param {string} option_label - The label of the selected option.
   */
  handleRadioChange = (option, option_label) => {
    this.props.setPredictionQuestionAnswer({
      id: this.props.id,
      option,
      option_label,
    });
  };

  /**
   * Renders a single choice option.
   *
   * @param {Object} option - The option object containing the label.
   * @param {number} index - The index of the option in the choices array.
   * @returns {React.Component} The rendered radio button option.
   */
  renderChoice = (option, index) => {
    const { id, checked } = this.props;
    return (
      <div className="input input-wrapper" key={index}>
        <div className="input-select">
          <input
            id={`scq${id}${index}`}
            type="radio"
            name={`answer${id}`}
            value={index}
            onChange={() => this.handleRadioChange(index, option.label)}
            checked={index === checked}
            tabIndex={0}
          />
          <label
            htmlFor={`scq${id}${index}`}
            className="response"
            aria-label={`${
              index === checked ? "selected, " : ""
            }${String.fromCharCode(97 + index)}, ${option.label}`}
          >
            <FormattedMessage
              id={option.label}
              defaultMessage={option.label}
              description=""
            />
          </label>
        </div>
      </div>
    );
  };

  /**
   * Renders the POSCQ component.
   *
   * @returns {React.Component} The rendered component.
   */
  render() {
    const { title, subtitle, index, choices, ariaLabel, intl } = this.props;
    const questionNumber = index % 2 === 0 ? "1" : "2";

    return (
      <div className="questionWrapper">
        <div className="predictionsOutcomeQuestion">
          <div className="question-header">
            {/* Question Title */}
            <h4
              style={{ marginTop: "0px", marginBottom: "0px" }}
              aria-label={intl.formatMessage({
                id: title,
                defaultMessage: title,
                description: "",
              })}
            >
              <FormattedMessage
                id={title}
                defaultMessage={title}
                description=""
              />
            </h4>
            {/* Question Subtitle */}
            <div style={{ marginBottom: "10px" }}>
              <FormattedMessage
                id={subtitle}
                defaultMessage={subtitle}
                description=""
              />
            </div>
          </div>
          {/* Question Number */}
          <h5 style={{ margin: "0 0 16px 8px" }}>Question {questionNumber}</h5>
          <div className="column-flex">
            <div className={`q-label choice${this.props.checked}`}>
              {/* Question Label */}
              <div
                className="q-label__inner"
                aria-label={`Question ${questionNumber}, ${intl.formatMessage({
                  id: ariaLabel,
                  defaultMessage: ariaLabel,
                  description: "",
                })}`}
              >
                <FormattedMessage
                  id={this.props.label}
                  defaultMessage={this.props.label}
                  description=""
                />
              </div>
              <div className="q-label__arrow"></div>
            </div>
            {/* Render Choices */}
            <div className="q-inputs">{choices.map(this.renderChoice)}</div>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * Maps Redux state to component props.
 *
 * @param {Object} state - The current state of the Redux store.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object} The mapped props.
 */
const mapStateToProps = (state, ownProps) => ({
  index: ownProps.id - 1,
  checked: state.poscq[ownProps.id] ? state.poscq[ownProps.id].index : null,
});

const POSCQIntl = injectIntl(POSCQ);

export default connect(mapStateToProps, { setPredictionQuestionAnswer })(
  POSCQIntl
);
